module.exports = __webpack_public_path__ + "4b8b4b377e8cb358cf886d13c7bb287c.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/assets/fonts/RobotoCondensed-Bold.ttf
// module id = 503
// module chunks = 0